import { PRODUCT_CODE } from '../../../../enums/productCode.enum';
import { getIsUsingReservations } from '../../../../helper/UtilityFunctions';
import { AppointmentCheckout } from '../../../organisms/Checkout/AppointmentCheckout';

type ConfirmationStepProps = {
  isFirstAppointment: boolean;
  isOffline: boolean;
  appointmentInfo: any;
};

export function ConfirmationStep({ isFirstAppointment, isOffline, appointmentInfo }: ConfirmationStepProps) {
  const isUsingReservations = getIsUsingReservations();
  const appointmentDuration = Number(appointmentInfo?.firstAppointmentDuration);
  const isLongDuration = isFirstAppointment && appointmentDuration === 30;

  const findingProductCode = () => {
    if (isUsingReservations) {
      return isFirstAppointment
        ? isOffline
          ? isLongDuration
            ? PRODUCT_CODE.RESERVATION_FIRST_APPOINTMENT_OFFLINE_LONG
            : PRODUCT_CODE.RESERVATION_FIRST_APPOINTMENT_OFFLINE_SHORT
          : isLongDuration
            ? PRODUCT_CODE.RESERVATION_FIRST_APPOINTMENT_ONLINE_LONG
            : PRODUCT_CODE.RESERVATION_FIRST_APPOINTMENT_ONLINE_SHORT
        : isOffline
          ? PRODUCT_CODE.RESERVATION_FOLLOW_UP_APPOINTMENT_OFFLINE
          : PRODUCT_CODE.RESERVATION_FOLLOW_UP_APPOINTMENT_ONLINE;
    } else {
      return isFirstAppointment
        ? isOffline
          ? isLongDuration
            ? PRODUCT_CODE.FIRST_APPOINTMENT_OFFLINE_LONG
            : PRODUCT_CODE.FIRST_APPOINTMENT_OFFLINE_SHORT
          : isLongDuration
            ? PRODUCT_CODE.FIRST_APPOINTMENT_ONLINE_LONG
            : PRODUCT_CODE.FIRST_APPOINTMENT_ONLINE_SHORT
        : isOffline
          ? PRODUCT_CODE.FOLLOW_UP_APPOINTMENT_OFFLINE
          : PRODUCT_CODE.FOLLOW_UP_APPOINTMENT_ONLINE;
    }
  };

  const determinedProductCode = findingProductCode();

  return <AppointmentCheckout appointmentInfo={appointmentInfo} productCode={determinedProductCode} />;
}
